import { useEffect, useState } from "react";
import { getPendingSyncCount, subscribePendingSyncCount } from "@/lib/pending-sync-count";

export function usePendingSyncCount(): number {
	const [count, setCount] = useState(getPendingSyncCount);
	useEffect(() => subscribePendingSyncCount(setCount), []);
	return count;
}
